class MapLibreStoreLocator {
    constructor(containerId, mapId, listId, searchId, markerImgUrl, rawLocations) {
        this.container = document.getElementById(containerId);
        this.mapEl = document.getElementById(mapId);
        this.listEl = document.getElementById(listId);
        this.searchEl = document.getElementById(searchId);
        this.markerImgUrl = markerImgUrl;
        this.locations = rawLocations;
        this.markers = [];

        if (this.mapEl) {
            this.initMap();
        }
    }

    initMap() {
        this.map = new maplibregl.Map({
            container: this.mapEl.id,
            style: 'https://tiles.openfreemap.org/styles/liberty',
            center: [-72.45, 40.88], // Centered around Long Island
            zoom: 9.5
        });

        this.map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
        this.buildMarkers();
        this.bindEvents();
    }

    buildMarkers() {
        this.locations.forEach(loc => {
            const el = document.createElement('div');
            el.className = 'custom-marker';
            el.style.backgroundImage = `url('${this.markerImgUrl}')`;

            const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(loc.address)}`;
            const popupHTML = `
        <div class="popup-body">
          <h4>${loc.title}</h4>
          <p>${loc.address}</p>
          ${loc.phone ? `<p>${loc.phone}</p>` : ''}
          <a class="directions-btn" href="${directionsUrl}" target="_blank" rel="noopener">Directions</a>
        </div>
      `;

            const popup = new maplibregl.Popup({ offset: 30, closeButton: true, closeOnClick: false })
                .setLngLat([parseFloat(loc.lng), parseFloat(loc.lat)])
                .setHTML(popupHTML);

            const marker = new maplibregl.Marker({ element: el })
                .setLngLat([parseFloat(loc.lng), parseFloat(loc.lat)])
                .setPopup(popup)
                .addTo(this.map);

            this.markers.push({ index: loc.index, markerInstance: marker, popupInstance: popup });

            el.addEventListener('click', (e) => {
                e.stopPropagation();
                this.focusOnLocation(loc.index, [parseFloat(loc.lng), parseFloat(loc.lat)], false);
            });
        });
    }

    bindEvents() {
        // List item clicks
        const listItems = this.listEl.querySelectorAll('.location-item');
        listItems.forEach(item => {
            item.addEventListener('click', () => {
                const index = parseInt(item.getAttribute('data-index'));
                const lat = parseFloat(item.getAttribute('data-lat'));
                const lng = parseFloat(item.getAttribute('data-lng'));
                this.focusOnLocation(index, [lng, lat], true);
            });
        });

        // Search bar functionality
        if (this.searchEl) {
            this.searchEl.addEventListener('input', (e) => {
                const query = e.target.value.toLowerCase().trim();
                listItems.forEach(item => {
                    const index = parseInt(item.getAttribute('data-index'));
                    const searchText = item.getAttribute('data-search').toLowerCase();
                    const mapMarkerObj = this.markers.find(m => m.index === index);

                    if (searchText.includes(query)) {
                        item.style.display = 'block';
                        if (mapMarkerObj) mapMarkerObj.markerInstance.addTo(this.map);
                    } else {
                        item.style.display = 'none';
                        if (mapMarkerObj) {
                            mapMarkerObj.markerInstance.remove();
                            mapMarkerObj.popupInstance.remove();
                        }
                    }
                });
            });
        }
    }

    focusOnLocation(selectedIndex, coords, scrollPage) {
        this.map.flyTo({ center: coords, zoom: 13.5, speed: 1.1 });

        const target = this.markers.find(m => m.index === selectedIndex);
        if (target) {
            this.markers.forEach(m => m.popupInstance.remove());
            target.popupInstance.addTo(this.map);
        }

        const listItems = this.listEl.querySelectorAll('.location-item');
        listItems.forEach(item => {
            item.classList.remove('active');
            if (parseInt(item.getAttribute('data-index')) === selectedIndex) {
                item.classList.add('active');
                item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });

        if (scrollPage) {
            this.mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}